import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { dashboardService } from '../services';
import { Appointment } from '../types';

/**
 * Hook para buscar próximos compromissos
 *
 * @param limit - Número máximo de compromissos (padrão: 4)
 *
 * @example
 * const { data: appointments, loading } = useUpcomingAppointments(5);
 */
export const useUpcomingAppointments = (
  limit = 4
): UseQueryResult<Appointment[], Error> => {
  return useQuery({
    queryKey: ['upcoming-appointments', limit],
    queryFn: () => dashboardService.getUpcomingAppointments(limit),
    staleTime: 3 * 60 * 1000, // 3 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: true,
    retry: 2,
  });
};